import { render } from "./ProfileCardButton.vue?vue&type=template&id=63fef43b&scoped=true"
import script from "./ProfileCardButton.vue?vue&type=script&lang=js"
export * from "./ProfileCardButton.vue?vue&type=script&lang=js"

import "./ProfileCardButton.vue?vue&type=style&index=0&id=63fef43b&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fef43b"]])

export default __exports__